<template>
  <div id="OutStockMgmt" class="out-stock-mgmt-page purchase-mgmt-page">
    <div class="page-header" ref="header">
      <div class="filter-card">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">日期</span>
            <el-date-picker v-model="date" type="date" placeholder="选择日期" size="small" clearable></el-date-picker>
          </div>
          <div class="filter-item">
            <span class="filter-label">货代公司</span>
            <el-select placeholder="全部" size="small" v-model="params.logisticsCompanyType" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in logisticsCompanys" :key="item.logisticsCompanyType" :label="item.logisticsCompanyName" :value="item.logisticsCompanyType"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">状态</span>
            <el-select placeholder="请选择" size="small" v-model="statusList" multiple collapse-tags class="filter-select-wide">
              <el-option label="出库中" :value="1"></el-option>
              <el-option label="已出库" :value="2"></el-option>
              <el-option label="出库完成" :value="3"></el-option>
              <el-option label="已拆分" :value="4"></el-option>
              <el-option label="已作废" :value="-1"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">货件类型</span>
            <el-select placeholder="全部" size="small" v-model="params.shipmentType" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="FBA货件" :value="1"></el-option>
              <el-option label="AWD货件" :value="2"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">SKU</span>
            <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sku" class="filter-input-wide"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">Asin</span>
            <el-input placeholder="请输入Asin" size="small" clearable v-model="params.asin" class="filter-input-wide"></el-input>
          </div>
          <div class="filter-item">
            <el-button type="primary" size="small" icon="el-icon-search" class="query-btn" @click="getData">查询</el-button>
          </div>
        </div>
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button size="small" plain icon="el-icon-upload2" @click="dialogFormVisible = true">导入</el-button>
            <el-button size="small" plain @click="goBoxMgmt">箱子管理</el-button>
            <el-button size="small" plain @click="goCalcPlan">方案测算</el-button>
            <el-button size="small" plain icon="el-icon-download" @click="dialogExportOutPlanVisible = true">导出</el-button>
            <el-button size="small" plain icon="el-icon-search" @click="dialogOutStockSearchVisible = true">出库检索</el-button>
            <el-button v-if="selectAsinStockList.length > 0" type="primary" size="small" icon="el-icon-printer" @click="dialogPrintOutStockVisible = true">打印出库单</el-button>
          </div>
          <div v-if="selectAsinStockList.length > 0" class="batch-toolbar">
            <span class="toolbar-tip">已选出库计划 {{ currentRow ? currentRow.planId : "" }}，可打印出库单</span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table ref="table" :data="planList" border stripe size="mini" :height="screenHeight" :highlight-current-row="true" class="mgmt-table" header-cell-class-name="table-header-cell" @selection-change="handleSelectionChange" v-loading="loading" element-loading-text="加载中...">
          <el-table-column type="selection" width="42" align="center" fixed="left"></el-table-column>
          <el-table-column prop="date" label="创建日期" width="88" align="center" fixed="left"></el-table-column>
          <el-table-column prop="shopName" label="店铺" width="56" align="center" fixed="left"></el-table-column>
          <el-table-column prop="planId" label="出库计划编号" width="108" align="center" fixed="left" show-overflow-tooltip></el-table-column>
          <el-table-column label="箱子" width="48" align="right" class-name="amount-col">
            <template slot-scope="scope">
              {{ getBoxCount(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="SKU数" width="56" align="right" class-name="amount-col">
            <template slot-scope="scope">
              {{ getOutStockSKUCount(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="商品数" width="64" align="right" class-name="amount-col">
            <template slot-scope="scope">
              {{ getOutStockCount(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="出库状态" width="80" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="getStatusTagType(scope.row.status)" effect="light">
                {{ getStatusLabel(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column width="96" align="center">
            <template slot="header">
              <div class="col-header-main">出库日期</div>
              <div class="col-header-sub">出库星期</div>
            </template>
            <template slot-scope="scope">
              <div class="row-item">{{ scope.row.outStockDate || "--" }}</div>
              <div class="row-item row-sub">{{ scope.row.outStockWeek || "--" }}</div>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center">
            <template slot="header">
              <div class="col-header-main">货代公司</div>
              <div class="col-header-sub">物流渠道</div>
            </template>
            <template slot-scope="scope">
              <div class="row-item" :title="scope.row.logisticsCompanyName">{{ scope.row.logisticsCompanyName || "--" }}</div>
              <div class="row-item row-sub" :title="scope.row.actualLogisticsName">{{ scope.row.actualLogisticsName || "--" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="开船日期" width="96" align="center">
            <template slot-scope="scope">
              {{ scope.row.sailingDate || "--" }}
            </template>
          </el-table-column>
          <el-table-column width="112" align="center">
            <template slot="header">
              <div class="col-header-main">预计提取</div>
              <div class="col-header-sub">预计入库</div>
            </template>
            <template slot-scope="scope">
              <div class="row-item">{{ scope.row.logisticsCompanyForecastExtractionDate || "--" }}</div>
              <div class="row-item row-sub">{{ scope.row.logisticsCompanyForecastStockInDate || "--" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="货件类型" width="88" align="center">
            <template slot-scope="scope">
              {{ getShipmentTypeLabel(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column width="128" align="left" sortable prop="fbaShipmentNo">
            <template slot="header">
              <div class="col-header-main">FBA货件编号</div>
              <div class="col-header-sub">物流转单号</div>
            </template>
            <template slot-scope="scope">
              <div class="row-item text-ellipsis" :title="scope.row.fbaShipmentNo">{{ scope.row.fbaShipmentNo || "--" }}</div>
              <div class="row-item row-sub text-ellipsis" :title="scope.row.logisticsNo">{{ scope.row.logisticsNo || "--" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="单价" width="64" align="right" class-name="amount-col">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.unitPrice) }}
            </template>
          </el-table-column>
          <el-table-column width="88" align="right" class-name="amount-col">
            <template slot="header">
              <div class="col-header-main">灵柚称重</div>
              <div class="col-header-sub">付款重量</div>
            </template>
            <template slot-scope="scope">
              <div class="row-item">{{ formatMoney(scope.row.lyTotalWeight) }}</div>
              <div class="row-item row-sub">{{ formatMoney(scope.row.payTotalWeight) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="物流费用" width="72" align="right" class-name="amount-col highlight-amount">
            <template slot-scope="scope">
              <span class="money-text">{{ formatMoney(scope.row.logisticsCost) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="付款状态" width="72" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.payStatus == 1 ? 'success' : 'info'" effect="light">
                {{ scope.row.payStatus == 1 ? "已付款" : "未付款" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column width="96" align="center">
            <template slot="header">
              <div class="col-header-main">提取日期</div>
              <div class="col-header-sub">入仓日期</div>
            </template>
            <template slot-scope="scope">
              <div class="row-item">{{ scope.row.logisticsExtractionDate || "--" }}</div>
              <div class="row-item row-sub">{{ scope.row.stockInAmazonDate || "--" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="接收日期" width="88" align="center">
            <template slot-scope="scope">
              {{ scope.row.receiveDate || "--" }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="96" align="center">
            <template slot-scope="scope">
              <div class="row-item">{{ formatCreateDate(scope.row.createTime) }}</div>
              <div class="row-item row-sub">{{ formatCreateTimePart(scope.row.createTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="预计上架" width="96" align="center">
            <template slot-scope="scope">
              {{ scope.row.forecastAvailableDate || "--" }}
            </template>
          </el-table-column>
          <el-table-column label="备注" width="100" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.remark || "" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" align="center" fixed="right" class-name="action-col">
            <template slot-scope="scope">
              <div class="action-cell">
                <el-button class="action-btn" type="text" size="small" @click="detail(scope.row)">查看</el-button>
                <el-button class="action-btn danger" type="text" size="small" v-if="scope.row.status == 1" @click="voidOutStockPlan(scope.row)">作废</el-button>
                <el-button class="action-btn warning" type="text" size="small" v-if="scope.row.status != -1 && scope.row.status != 4" @click="confirmOutStockPlan(scope.row)">
                  {{ scope.row.status == 1 ? "确认出库" : "编辑出库" }}
                </el-button>
                <el-button class="action-btn" type="text" size="small" v-if="scope.row.status == 2 || scope.row.status == 3" @click="editForecastAvailableDate(scope.row)">编辑上架</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination ref="pageNav" layout="total, prev, pager, next" background :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"></el-pagination>
      </div>
    </div>

    <el-dialog title="编辑预计上架日期" :visible.sync="dialogForecastAvailableDateVisible" width="600px">
      <div class="form-line">
        <span class="form-label">预计上架日期</span>
        <el-date-picker v-model="forecastAvailableDate" type="date" placeholder="选择日期" style="margin-left: 20px"> </el-date-picker>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogForecastAvailableDateVisible = false">取消</el-button>
        <el-button class="opreate-btn" type="primary" size="small" @click="handleForecastAvailableDateConfirm">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="确认出库" :visible.sync="dialogOutStockVisible" width="600px">
      <div class="form-line">
        <span class="form-label">货件类型</span>
        <el-radio v-model="outStockParams.shipmentType" :label="1">FBA货件</el-radio>
        <el-radio v-model="outStockParams.shipmentType" :label="2">AWD货件</el-radio>
      </div>
      <div class="form-line">
        <span class="form-label">FBA货件编号</span>
        <el-input class="form-input" placeholder="请输入" v-model="outStockParams.fbaShipmentNo" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">出库日期</span>
        <el-date-picker class="form-date" v-model="outStockDate" type="date" placeholder="选择日期" size="small"> </el-date-picker>
      </div>
      <div class="form-line">
        <span class="form-label">出库星期</span>
        <span>{{ outStockParams.outStockWeek }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">货代公司</span>
        <el-select class="form-select" placeholder="请选择" size="small" v-model="outStockParams.logisticsCompanyType">
          <el-option v-for="item in logisticsCompanys" :label="item.logisticsCompanyName" :value="item.logisticsCompanyType"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <span class="form-label">物流渠道</span>
        <el-select class="form-select" placeholder="请选择" size="small" v-model="outStockParams.actualLogisticsType">
          <el-option v-for="item in actualLogistics" :label="item.actualLogisticsName" :value="item.actualLogisticsType"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <span class="form-label">开船日期</span>
        <el-date-picker class="form-date" v-model="sailingDate" type="date" placeholder="选择日期" size="small"> </el-date-picker>
      </div>
      <div class="form-line">
        <span class="form-label">货代预计提取日期</span>
        <el-date-picker class="form-date" v-model="logisticsCompanyForecastExtractionDate" type="date" placeholder="选择日期" size="small"> </el-date-picker>
      </div>
      <div class="form-line">
        <span class="form-label">货代预计入库日期</span>
        <el-date-picker class="form-date" v-model="logisticsCompanyForecastStockInDate" type="date" placeholder="选择日期" size="small"> </el-date-picker>
      </div>
      <div class="form-line">
        <span class="form-label">预计上架日期</span>
        <el-date-picker class="form-date" v-model="forecastAvailableDate" type="date" placeholder="选择日期" size="small"> </el-date-picker>
      </div>
      <div class="form-line">
        <span class="form-label">货代单号</span>
        <el-input class="form-input" placeholder="请输入" v-model="outStockParams.logisticsCompanyNo" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">物流转单号</span>
        <el-input class="form-input" placeholder="请输入" v-model="outStockParams.logisticsNo" size="small" clearable> </el-input>
      </div>

      <div class="form-line">
        <span class="form-label">单价</span>
        <el-input type="number" class="form-input" placeholder="请输入" v-model="outStockParams.unitPrice" size="small" clearable> </el-input>
      </div>
      <div class="form-line" v-if="editRow">
        <span class="form-label">箱子称重</span>
        <el-table :data="editRow.boxs" stripe size="mini" :highlight-current-row="true" style="display: inline-block; width: 300px; vertical-align: text-top" show-summary>
          <el-table-column prop="boxId" label="箱子编号" width="100px" align="left" :key="117"> </el-table-column>
          <el-table-column prop="lyWeight" label="灵柚称重" width="100px" :key="118">
            <template slot-scope="scope">
              <el-input type="number" class="form-input" v-model="scope.row.lyWeight" size="small" style="width: 80px" clearable controls-position="none"> </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="payWeight" label="付款重量" width="100px" :key="119">
            <template slot-scope="scope">
              <el-input type="number" class="form-input" v-model="scope.row.payWeight" size="small" style="width: 80px" clearable controls-position="none"> </el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="form-line">
        <span class="form-label">单价优惠</span>
        <el-input type="number" class="form-input" placeholder="请输入" v-model="outStockParams.unitPriceDiscount" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">合计优惠</span>
        <el-input type="number" class="form-input" placeholder="请输入" v-model="outStockParams.totalCostDiscount" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">物流费用</span>
        <span>{{ outStockParams.logisticsCost }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">付款状态</span>
        <el-radio v-model="outStockParams.payStatus" :label="0">未付款</el-radio>
        <el-radio v-model="outStockParams.payStatus" :label="1">已付款</el-radio>
      </div>
      <div class="form-line">
        <span class="form-label">实际提取日期</span>
        <el-date-picker class="form-date" v-model="logisticsExtractionDate" type="date" placeholder="选择日期" size="small"> </el-date-picker>
      </div>
      <div class="form-line">
        <span class="form-label">实际入仓日期</span>
        <el-date-picker class="form-date" v-model="stockInAmazonDate" type="date" placeholder="选择日期" size="small"> </el-date-picker>
      </div>
      <div class="form-line">
        <span class="form-label">实际接收日期</span>
        <el-date-picker class="form-date" v-model="receiveDate" type="date" placeholder="选择日期" size="small"> </el-date-picker>
      </div>
      <div class="form-line">
        <span class="form-label">备注</span>
        <el-input type="text" class="form-input" placeholder="请输入" v-model="outStockParams.remark" size="small" clearable> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogOutStockVisible = false">取消</el-button>
        <el-button class="opreate-btn" type="primary" size="small" @click="handleOutStockConfirm">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="dialogFormVisible" width="560px">
      <el-form>
        <el-form-item label="导入FBA货件列表" label-width="150px">
          <el-upload ref="uploadFBAShipment" class="upload-demo" action="/node/importFBAShipment" :auto-upload="false" :on-success="onUploadSuccess" :on-error="onUploadError" :before-upload="beforeUpload" :limit="1">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入AWD货件列表" label-width="150px">
          <el-upload ref="uploadAWDShipment" class="upload-demo" action="/node/importAWDShipment" accept=".csv" :auto-upload="false" :on-success="onUploadSuccess" :on-error="onUploadError" :before-upload="beforeUpload" :limit="1">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="importData">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="打印出库单" :visible.sync="dialogPrintOutStockVisible" width="710px">
      <div class="plan-conent" id="subOutputRank-print" style="padding: 10px">
        <div class="title-content" v-if="currentRow">
          <span class="title-label">出口计划编号：</span>
          <span class="title-text">{{ currentRow.planId }}</span>
          <span class="title-label" style="margin-left: 20px">头程物流：</span>
          <span class="title-text">{{ getLogisticsTypeLabel(currentRow.logisticsType) }}</span>
          <span class="title-label" style="margin-left: 20px">店铺名称：</span>
          <span class="title-text">{{ currentRow.shopName }}</span>
          <span class="title-label" style="margin-left: 20px">出库日期：</span>
          <span class="title-text">{{ currentRow.date }}</span>
        </div>
        <el-table ref="noBoxTable" :data="selectAsinStockList" border size="mini" :highlight-current-row="true" show-summary style="font-size: 12px; font-weight: bold; border-color: gray">
          <!-- <el-table-column prop="shopName" label="店铺名称" width="30px" :key="10"> </el-table-column> -->
          <!-- <el-table-column prop="productName" label="产品名称" width="280px;padding:0px" :key="11">
            <template slot-scope="scope">
              <div style="border-bottom: solid 1px gray">
                <span style="width: 115px; height: 20px; line-height: 20px; padding-left: 3px; padding-top: 3px; display: inline-block; border-right: solid 1px gray">{{ scope.row.productName }}</span>
                <span style="width: 65px; height: 20px; line-height: 20px; padding-left: 3px; padding-top: 3px; display: inline-block; border-right: solid 1px gray">{{ scope.row.productColorName }}</span>
                <span style="width: 65px; height: 20px; line-height: 20px; padding-left: 3px; display: inline-block">{{ scope.row.model }}</span>
              </div>
              <div style="margin-top: 3px; height: 15px; line-height: 15px; padding-left: 3px; font-weight: 400">{{ scope.row.sku }}</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="productColorName" label="颜色" width="60px" :key="13" sortable> </el-table-column> -->
          <!-- <el-table-column prop="sku" label="SKU" width="220px" :key="10" sortable> </el-table-column> -->
          <!-- <el-table-column prop="model" label="机型" width="55px" :key="12" sortable> </el-table-column> -->
          <el-table-column label="序号" width="40px" :key="12161">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="产品名称" width="110px" :key="161">
            <template slot-scope="scope">
              <div style="height: 20px; line-height: 20px">{{ scope.row.productName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="productColorName" label="颜色" width="70px" :key="162"> </el-table-column>
          <el-table-column prop="model" label="机型" width="90px" :key="163"> </el-table-column>
          <!-- <el-table-column label="打包类型" width="45px" align="right" :key="1161">
            <template slot-scope="scope">
              <div>{{ scope.row.boxType == "groupBox" ? "五箱" : "单箱" }}</div>
            </template>
          </el-table-column> -->
          <el-table-column prop="totalOutStockCount" label="出库数量" width="45px" align="right" :key="16"> </el-table-column>
          <!-- <el-table-column prop="kdOutStockCount" label="红单数量" width="45px" align="right" :key="11611">
            <template slot-scope="scope">
              <div>{{ scope.row.kdOutStockCount > 0 ? scope.row.kdOutStockCount : "" }}</div>
            </template>
          </el-table-column> -->
          <el-table-column prop="perBoxOutStockCount" label="每箱数量" width="45px" align="right" :key="1621">
            <template slot-scope="scope">
              <div>{{ scope.row.perBoxOutStockCount > 0 ? scope.row.perBoxOutStockCount : "" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="fictitiousQuantity" label="虚增数量" width="45px" align="right" :key="1162">
            <template slot-scope="scope">
              <div>{{ scope.row.fictitiousQuantity > 0 ? scope.row.fictitiousQuantity : "" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="localInventory" label="本地库存数量" width="45px" align="right" :key="164"> </el-table-column>
          <!-- <el-table-column prop="hkOutStockCount" label="海卡数量" width="40px" align="right" :key="163"> </el-table-column> -->
          <el-table-column prop="fnsku" label="FNSKU" width="110px" :key="10" align="center"> </el-table-column>
          <el-table-column label="备注" width="45px" :key="110"> </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogPrintOutStockVisible = false">取消</el-button>
        <el-button class="opreate-btn" v-print="'#subOutputRank-print'" type="primary" size="small">打印出库单</el-button>
      </div>
    </el-dialog>

    <out-stock-sku-search-dialog :visible.sync="dialogOutStockSearchVisible"></out-stock-sku-search-dialog>

    <el-dialog title="导出" :visible.sync="dialogExportOutPlanVisible" width="710px">
      <div class="opreate-box">
        <div class="form-line">
          <span class="form-label">店铺</span>
          <el-select class="form-select" placeholder="请选择" size="small" v-model="exportParams.shopType">
            <el-option label="全部"></el-option>
            <el-option label="灵柚" :value="1"></el-option>
            <el-option label="萧发" :value="2"></el-option>
            <el-option label="誉腾" :value="3"></el-option>
            <el-option label="甄昂" :value="4"></el-option>
            <el-option label="杭傲" :value="5"></el-option>
            <el-option label="众联" :value="8"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <span class="form-label">出库日期</span>
          <el-date-picker v-model="exportMonth" type="month" placeholder="选择月份" size="small"> </el-date-picker>
        </div>
        <div slot="footer" class="dialog-footer" style="padding: 20px 0px 20px 130px">
          <el-button type="primary" size="small" @click="dialogExportOutPlanVisible = false">取消</el-button>
          <el-button class="opreate-btn" type="primary" size="small" @click="fetchOutPlanList">查询</el-button>

          <el-button class="opreate-btn" type="primary" size="small"><download-excel :data="exportOutPlanList" :fields="exportTitles" :name="getExportName()">导出</download-excel></el-button>
        </div>
      </div>

      <div class="plan-conent" id="subOutputRank-print2">
        <el-table :data="exportOutPlanList" border size="mini" :highlight-current-row="true" style="font-size: 12px; font-weight: bold; border-color: gray">
          <el-table-column label="序号" width="60px" :key="12161">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column prop="shopName" label="店铺名称" width="120px" :key="163"> </el-table-column>
          <el-table-column prop="productName" label="产品名称" width="200px" :key="161">
            <template slot-scope="scope">
              <div style="height: 20px; line-height: 20px">{{ scope.row.productName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="outStockCount" label="出库数量" :key="162" align="right"> </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import OutStockSkuSearchDialog from "./children/OutStockSkuSearchDialog.vue";

export default {
  components: {
    OutStockSkuSearchDialog,
  },
  data() {
    return {
      planList: [],
      statusList: [1, 2, 3],
      params: {
        statusList: "",
        logisticsType: "",
        beginIndex: 0,
        pageSize: 100,
        asin: "",
        sku: "",
        shipmentType: "",
      },
      outStockParams: {
        outStockDate: "",
        outStockWeek: "",
        logisticsCompanyType: "",
        logisticsCompanyName: "",
        actualLogisticsType: "",
        actualLogisticsName: "",
        sailingDate: "",
        logisticsCompanyForecastExtractionDate: "",
        logisticsCompanyForecastStockInDate: "",
        forecastAvailableDate: "",
        forecastAvailableTime: "",
        shipmentType: 1,
        fbaShipmentNo: "",
        logisticsCompanyNo: "",
        logisticsNo: "",
        unitPrice: 0,
        lyTotalWeight: 0,
        payTotalWeight: 0,
        lyBoxWeights: "",
        payBoxWeights: "",
        unitPriceDiscount: 0,
        totalCostDiscount: 0,
        logisticsCost: 0,
        payStatus: 0,
        logisticsExtractionDate: "",
        stockInAmazonDate: "",
        receiveDate: "",
        remark: "",
      },
      outStockDate: new Date(),
      sailingDate: null,
      logisticsCompanyForecastExtractionDate: null,
      logisticsCompanyForecastStockInDate: null,
      logisticsExtractionDate: null,
      stockInAmazonDate: null,
      receiveDate: null,
      date: "",
      total: 0,
      pageCount: 1,
      loading: false,
      screenHeight: 400,
      forecastAvailableDate: null,
      dialogForecastAvailableDateVisible: false,
      dialogOutStockVisible: false,
      dialogFormVisible: false,
      importErrorMessage: "",
      editRow: null,
      uploadCount: 0,
      logisticsCompanys: [
        {
          logisticsCompanyType: 10001,
          logisticsCompanyName: "顺丰",
        },
        {
          logisticsCompanyType: 10002,
          logisticsCompanyName: "美通",
        },
        {
          logisticsCompanyType: 10003,
          logisticsCompanyName: "德邦",
        },
        {
          logisticsCompanyType: 10004,
          logisticsCompanyName: "山海",
        },
        {
          logisticsCompanyType: 10005,
          logisticsCompanyName: "雪球",
        },
        {
          logisticsCompanyType: 10006,
          logisticsCompanyName: "纽酷国际",
        },
        {
          logisticsCompanyType: 10007,
          logisticsCompanyName: "一八供应链",
        },
        {
          logisticsCompanyType: 10008,
          logisticsCompanyName: "先至",
        },
        {
          logisticsCompanyType: 10009,
          logisticsCompanyName: "东一国际",
        },
        {
          logisticsCompanyType: 10010,
          logisticsCompanyName: "云驼",
        },
        {
          logisticsCompanyType: 10011,
          logisticsCompanyName: "讯合",
        },
      ],
      actualLogistics: [
        {
          actualLogisticsType: 20001,
          actualLogisticsName: "红单",
        },
        {
          actualLogisticsType: 20002,
          actualLogisticsName: "空派",
        },
        {
          actualLogisticsType: 20003,
          actualLogisticsName: "美森",
        },
        {
          actualLogisticsType: 20004,
          actualLogisticsName: "普船",
        },
      ],
      selectRows: [],
      selectAsinStockList: [],
      dialogPrintOutStockVisible: false,
      currentRow: null,
      shopList: [],
      exportMonth: new Date(),
      exportParams: {
        shopType: 1,
        month: "",
      },
      exportOutPlanList: [],
      dialogExportOutPlanVisible: false,
      dialogOutStockSearchVisible: false,
    };
  },
  watch: {
    "params.productType": {
      handler: function (newValue, oldValue) {
        let parentProduct = this.productList.find(pd => pd.productType == newValue);
        let checkColors = Array.isArray(parentProduct.checkColors) ? parentProduct.checkColors : JSON.parse(parentProduct.checkColors);
        let checkModels = JSON.parse(parentProduct.checkModels);

        this.colorList = [];
        this.modelList = [...checkModels];

        colors.forEach(color => checkColors.includes(color.key) && this.colorList.push(color));
      },
    },
    outStockDate: {
      handler(val, olVal) {
        this.outStockParams.outStockWeek = this.getWeek(val);
      },
    },
    "outStockParams.unitPrice": {
      handler(val, olVal) {
        this.initLogisticsCost();
      },
      deep: true,
    },
    "outStockParams.unitPriceDiscount": {
      handler(val, olVal) {
        this.initLogisticsCost();
      },
      deep: true,
    },
    "outStockParams.totalCostDiscount": {
      handler(val, olVal) {
        this.initLogisticsCost();
      },
      deep: true,
    },
    "editRow.boxs": {
      handler(val, olVal) {
        this.initLogisticsCost();
      },
      deep: true,
    },
  },
  mounted() {
    this.getData();
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const pagination = panel.querySelector(".pagination-box");
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const paginationHeight = pagination ? pagination.offsetHeight : 0;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom - paginationHeight - 12;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    formatMoney(value) {
      if (value === "" || value === null || value === undefined) {
        return "";
      }
      return parseFloat(value).toFixed(2);
    },
    formatCreateDate(value) {
      if (!value) {
        return "--";
      }
      return new Date(value).format("yyyy-MM-dd");
    },
    formatCreateTimePart(value) {
      if (!value) {
        return "--";
      }
      return new Date(value).format("hh:mm:ss");
    },
    getStatusTagType(status) {
      if (status == 1) {
        return "warning";
      }
      if (status == 2) {
        return "primary";
      }
      if (status == 3) {
        return "success";
      }
      if (status == 4) {
        return "info";
      }
      if (status == -1) {
        return "danger";
      }
      return "info";
    },
    getExportName() {
      return "出库统计表_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    detail(row) {
      window.open("/client/outStockMgmt/detail?planId=" + row.planId);
    },
    goBoxMgmt() {
      window.open("/client/outStockMgmt/outStockBox");
    },
    goCalcPlan() {
      window.open("/client/outStockMgmt/outStockCalcPlan");
    },
    fetchOutPlanList() {
      this.exportParams.month = this.exportMonth != "" && this.exportMonth ? this.exportMonth.format("yyyy-MM") : null;
      console.log(this.exportParams);
      requestModules.fetchOutPlanList(this.exportParams).then(res => {
        this.exportOutPlanList = res.ldata;
      });
    },
    handleSelectionChange(rows) {
      if (rows.length > 1) {
        let selectedRow = rows.pop();
        this.currentRow = selectedRow;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(selectedRow);
        // this.initPlanForPrint(selectedRow);
        // this.selectAsinStockList = [selectedRow];
      } else if (rows.length == 1) {
        this.selectAsinStockList = rows;
        let selectedRow = rows.pop();
        this.currentRow = selectedRow;
        this.selectAsinStockList = [selectedRow];
        this.initPlanForPrint(selectedRow);
      } else {
        this.selectAsinStockList = [];
      }
      // console.log(this.currentRow);
    },
    initPlanForPrint(plan) {
      this.selectAsinStockList = [];
      let stockList = [...plan.noBoxAsinStockList];
      plan.boxs.forEach(box => {
        box.asinStockList.forEach(asinStock => {
          stockList.push({ ...asinStock, boxType: box.boxType });
        });
      });
      let skuSet = new Set([]);
      stockList.forEach(item => skuSet.add(item.sku));
      let skuList = [...skuSet];
      skuList.forEach(sku => {
        let data = {
          totalOutStockCount: 0,
          kdOutStockCount: 0,
          msOutStockCount: 0,
          hkOutStockCount: 0,
          totalFictitiousQuantity: 0,
        };
        let list = stockList.filter(asinStock => asinStock.sku == sku);
        if (list.length > 0) {
          data = {
            ...data,
            ...list[0],
            perBoxOutStockCount: 0,
          };
          list.forEach(item => {
            data.totalOutStockCount += item.outStockCount;
            data.totalFictitiousQuantity += item.outStockCount;
          });
          plan.logisticsType == 2 && (data.perBoxOutStockCount = Math.round(data.totalOutStockCount / 5));
          this.selectAsinStockList.push(data);
        }
      });

      this.selectAsinStockList.sort((a, b) => a.sku.localeCompare(b.sku));

      console.log(this.selectAsinStockList);
    },
    initSelectionChange(rows) {
      this.selectAsinStockList = [];
      let stockList = [];
      let kdStockList = [];
      let msStockList = [];
      let hkStockList = [];
      rows.forEach(row => {
        let list = [...row.noBoxAsinStockList];
        row.boxs.forEach(box => {
          box.asinStockList.forEach(asinStock => {
            list.push({ ...asinStock, boxType: box.boxType });
          });
          // list = list.concat(box.asinStockList);
        });
        stockList = stockList.concat(list);
        row.logisticsType == 1 && (kdStockList = kdStockList.concat(list));
        row.logisticsType == 2 && (msStockList = msStockList.concat(list));
        row.logisticsType == 3 && (hkStockList = hkStockList.concat(list));
      });
      let skuSet = new Set([]);
      stockList.forEach(item => skuSet.add(item.sku));
      let skuList = [...skuSet];
      skuList.forEach(sku => {
        let kdList = kdStockList.filter(stockItem => stockItem.sku == sku);
        let msList = msStockList.filter(stockItem => stockItem.sku == sku);
        let hkList = hkStockList.filter(stockItem => stockItem.sku == sku);

        let data = {
          totalOutStockCount: 0,
          kdOutStockCount: 0,
          msOutStockCount: 0,
          hkOutStockCount: 0,
          totalFictitiousQuantity: 0,
        };
        if (kdList.length > 0) {
          data = {
            ...data,
            ...kdList[0],
          };
          kdList.forEach(item => {
            data.totalOutStockCount += item.outStockCount;
            data.kdOutStockCount += item.outStockCount;
            data.totalFictitiousQuantity += item.outStockCount;
          });
        }
        if (msList.length > 0) {
          data = {
            ...data,
            ...msList[0],
          };
          msList.forEach(item => {
            data.totalOutStockCount += item.outStockCount;
            data.msOutStockCount += item.outStockCount;
            data.totalFictitiousQuantity += item.outStockCount;
          });
        }
        if (hkList.length > 0) {
          data = {
            ...data,
            ...hkList[0],
          };
          hkList.forEach(item => {
            data.totalOutStockCount += item.outStockCount;
            data.hkOutStockCount += item.outStockCount;
            data.totalFictitiousQuantity += item.outStockCount;
          });
        }
        this.selectAsinStockList.push(data);
      });

      this.selectAsinStockList.sort((a, b) => a.sku.localeCompare(b.sku));
    },
    importData() {
      const fbaFiles = (this.$refs.uploadFBAShipment && this.$refs.uploadFBAShipment.uploadFiles) || [];
      const awdFiles = (this.$refs.uploadAWDShipment && this.$refs.uploadAWDShipment.uploadFiles) || [];
      if (fbaFiles.length === 0 && awdFiles.length === 0) {
        this.$message({
          type: "error",
          message: "请选择要导入的文件",
        });
        return;
      }
      this.importErrorMessage = "";
      this.dialogFormVisible = false;
      fbaFiles.length > 0 && this.$refs.uploadFBAShipment.submit();
      awdFiles.length > 0 && this.$refs.uploadAWDShipment.submit();
    },
    getWeek(date) {
      const dayOfWeek = date.getDay();

      // 将数字转换为对应的星期几
      const days = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
      return days[dayOfWeek];
    },
    handleOutStockConfirm() {
      this.outStockParams.sailingDate = this.sailingDate ? this.sailingDate.format("yyyy-MM-dd") : "";
      this.outStockParams.logisticsCompanyForecastExtractionDate = this.logisticsCompanyForecastExtractionDate ? this.logisticsCompanyForecastExtractionDate.format("yyyy-MM-dd") : "";
      this.outStockParams.logisticsCompanyForecastStockInDate = this.logisticsCompanyForecastStockInDate ? this.logisticsCompanyForecastStockInDate.format("yyyy-MM-dd") : "";
      this.outStockParams.forecastAvailableDate = this.forecastAvailableDate ? this.forecastAvailableDate.format("yyyy-MM-dd") : "";
      this.outStockParams.logisticsExtractionDate = this.logisticsExtractionDate ? this.logisticsExtractionDate.format("yyyy-MM-dd") : "";
      this.outStockParams.stockInAmazonDate = this.stockInAmazonDate ? this.stockInAmazonDate.format("yyyy-MM-dd") : "";
      this.outStockParams.receiveDate = this.receiveDate ? this.receiveDate.format("yyyy-MM-dd") : "";
      this.outStockParams.outStockDate = this.outStockDate ? this.outStockDate.format("yyyy-MM-dd") : "";

      let forecastAvailableTime = new Date(this.outStockParams.forecastAvailableDate + " 00:00:00").getTime() + 24 * 60 * 60 * 1000 - 1;
      this.outStockParams.forecastAvailableTime = forecastAvailableTime;

      this.initLogisticsCost();

      console.log(JSON.stringify(this.outStockParams));
      let params = {
        ...this.outStockParams,
        id: this.editRow._id,
        status: 2,
      };
      this.dialogOutStockVisible = false;
      requestModules.addOrUpdateOutStockPlan(params).then(res => {
        this.getData();
      });
    },
    initLogisticsCost() {
      let lyTotalWeight = 0;
      let payTotalWeight = 0;
      let lyBoxWeights = [];
      let payBoxWeights = [];
      this.editRow &&
        this.editRow.boxs.forEach(box => {
          lyBoxWeights.push({
            boxId: box.boxId,
            weight: box.lyWeight > 0 ? Number(box.lyWeight) : 0,
          });
          payBoxWeights.push({
            boxId: box.boxId,
            weight: box.payWeight > 0 ? Number(box.payWeight) : 0,
          });
          lyTotalWeight += box.lyWeight > 0 ? Number(box.lyWeight) : 0;
          payTotalWeight += box.payWeight > 0 ? Number(box.payWeight) : 0;
        });

      this.outStockParams.lyTotalWeight = lyTotalWeight;
      this.outStockParams.payTotalWeight = payTotalWeight;
      this.outStockParams.lyBoxWeights = JSON.stringify(lyBoxWeights);
      this.outStockParams.payBoxWeights = JSON.stringify(payBoxWeights);

      let logisticsCompany = this.logisticsCompanys.find(company => company.logisticsCompanyType == this.outStockParams.logisticsCompanyType);
      let actualLogistics = this.actualLogistics.find(item => item.actualLogisticsType == this.outStockParams.actualLogisticsType);

      logisticsCompany && (this.outStockParams.logisticsCompanyName = logisticsCompany.logisticsCompanyName);
      actualLogistics && (this.outStockParams.actualLogisticsName = actualLogistics.actualLogisticsName);

      this.outStockParams.logisticsCost = parseFloat(((this.outStockParams.unitPrice - Number(this.outStockParams.unitPriceDiscount)) * this.outStockParams.payTotalWeight - Number(this.outStockParams.totalCostDiscount)).toFixed(2));
    },
    getShipmentTypeLabel(row) {
      return row && row.shipmentType == 2 ? "AWD货件" : "FBA货件";
    },
    getLogisticsTypeLabel(logisticsType) {
      let label = "";
      logisticsType == 1 && (label = "红单快递");
      logisticsType == 2 && (label = "美森正班");
      logisticsType == 3 && (label = "海派海卡");
      return label;
    },
    voidOutStockPlan(row) {
      this.$confirm("是否确认作废出库计划？", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.addOrUpdateOutStockPlan({ id: row._id, status: -1 }).then(res => {
          this.getData();
        });
      });
    },
    completeOutStockPlan(row) {
      this.$confirm("是否确认完成出库？", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.addOrUpdateOutStockPlan({ id: row._id, status: 3 }).then(res => {
          this.getData();
        });
      });
    },
    confirmOutStockPlan(row) {
      this.editRow = row;
      if (row.noBoxAsinStockList.length > 0) {
        this.$message({
          type: "error",
          message: "存在未分配商品，不能完成出库！",
        });
        return;
      }

      this.outStockParams.outStockWeek = this.getWeek(this.outStockDate);
      this.outStockParams.shipmentType = row.shipmentType == 2 ? 2 : 1;
      this.dialogOutStockVisible = true;

      if (row.status == 1 || row.status == -1) {
        let logisticsType = row.logisticsType;
        let offTime = 0;
        logisticsType == 1 && (offTime = 15 * 24 * 60 * 60 * 1000 - 1);
        logisticsType == 2 && (offTime = 29 * 24 * 60 * 60 * 1000 - 1);
        logisticsType == 3 && (offTime = 43 * 24 * 60 * 60 * 1000 - 1);
        let today = new Date().format("yyyy-MM-dd");
        let todayTime = new Date(today + " 00:00:00").getTime();
        this.forecastAvailableDate = new Date(todayTime + offTime);
        this.outStockParams.forecastAvailableTime = todayTime + offTime;
        this.sailingDate = null;
      } else if (row.status == 2 || row.status == 3) {
        this.sailingDate = row.sailingDate ? new Date(row.sailingDate) : null;
        this.logisticsCompanyForecastExtractionDate = row.logisticsCompanyForecastExtractionDate ? new Date(row.logisticsCompanyForecastExtractionDate) : null;
        this.logisticsCompanyForecastStockInDate = row.logisticsCompanyForecastStockInDate ? new Date(row.logisticsCompanyForecastStockInDate) : null;
        this.forecastAvailableDate = row.forecastAvailableDate ? new Date(row.forecastAvailableDate) : null;
        this.logisticsExtractionDate = row.logisticsExtractionDate ? new Date(row.logisticsExtractionDate) : null;
        this.stockInAmazonDate = row.stockInAmazonDate ? new Date(row.stockInAmazonDate) : null;
        this.receiveDate = row.receiveDate ? new Date(row.receiveDate) : null;
        this.outStockDate = row.outStockDate ? new Date(row.outStockDate) : new Date();
        this.outStockParams.payStatus = Number(row.payStatus);
        this.outStockParams.outStockDate = row.outStockDate;
        this.outStockParams.outStockWeek = row.outStockWeek;
        this.outStockParams.logisticsCompanyType = ~~row.logisticsCompanyType;
        this.outStockParams.logisticsCompanyName = row.logisticsCompanyName;
        this.outStockParams.actualLogisticsType = ~~row.actualLogisticsType;
        this.outStockParams.actualLogisticsName = row.actualLogisticsName;
        this.outStockParams.sailingDate = row.sailingDate;
        this.outStockParams.logisticsCompanyForecastExtractionDate = row.logisticsCompanyForecastExtractionDate;
        this.outStockParams.logisticsCompanyForecastStockInDate = row.logisticsCompanyForecastStockInDate;
        this.outStockParams.forecastAvailableDate = row.forecastAvailableDate;
        this.outStockParams.forecastAvailableTime = row.forecastAvailableTime;
        this.outStockParams.fbaShipmentNo = row.fbaShipmentNo;
        this.outStockParams.logisticsNo = row.logisticsNo;
        this.outStockParams.unitPrice = Number(row.unitPrice);
        this.outStockParams.lyTotalWeight = Number(row.lyTotalWeight);
        this.outStockParams.payTotalWeight = Number(row.payTotalWeight);
        this.outStockParams.unitPriceDiscount = Number(row.unitPriceDiscount);
        this.outStockParams.totalCostDiscount = Number(row.totalCostDiscount);
        this.outStockParams.logisticsCost = Number(row.logisticsCost);
        this.outStockParams.logisticsExtractionDate = row.logisticsExtractionDate;
        this.outStockParams.stockInAmazonDate = row.stockInAmazonDate;
        this.outStockParams.receiveDate = row.receiveDate;
        this.outStockParams.remark = row.remark;
        this.outStockParams.logisticsCompanyNo = row.logisticsCompanyNo;
      }
    },
    editForecastAvailableDate(row) {
      this.dialogForecastAvailableDateVisible = true;
      this.editRow = row;
      this.forecastAvailableDate = new Date(row.forecastAvailableDate);
    },
    handleForecastAvailableDateConfirm() {
      if (!this.forecastAvailableDate) {
        this.$message({
          message: "请选择预计上架日期",
          type: "error",
        });
        return;
      }

      console.log(this.forecastAvailableDate.format("yyyy-MM-dd"));
      let forecastAvailableDate = this.forecastAvailableDate.format("yyyy-MM-dd");
      let forecastAvailableTime = new Date(forecastAvailableDate + " 00:00:00").getTime() + 24 * 60 * 60 * 1000 - 1;

      this.dialogForecastAvailableDateVisible = false;
      requestModules.addOrUpdateOutStockPlan({ id: this.editRow._id, forecastAvailableDate, forecastAvailableTime }).then(res => {
        this.getData();
      });
    },
    getData() {
      this.loading = true;
      this.date && (this.params.date = this.date.format("yyyy-MM-dd"));
      this.params.statusList = JSON.stringify(this.statusList);
      requestModules
        .fetchOutStockPlans(this.params)
        .then(res => {
          this.planList = res.ldata;
          this.total = res.total;
          this.loading = false;
          this.calculateHeight();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getStatusLabel(row) {
      let label = "";
      row.status == 2 && (label = "已出库");
      row.status == 3 && (label = "出库完成");
      row.status == -1 && (label = "已作废");
      row.status == 1 && (label = "出库中");
      row.status == 4 && (label = "已拆分");
      return label;
    },
    getBoxCount(row) {
      let boxs = (row && row.boxs) || [];
      let count = 0;
      boxs.forEach(box => {
        if (box.boxType == "groupBox") {
          count += box.groupBoxsCount > 0 ? ~~box.groupBoxsCount : 5;
        } else {
          count += 1;
        }
      });
      return count;
    },
    getOutStockCount(row) {
      let noBoxAsinStockList = (row && row.noBoxAsinStockList) || [];
      let boxs = (row && row.boxs) || [];
      let outStockCount = 0;
      noBoxAsinStockList.forEach(asinStock => (outStockCount += asinStock.outStockCount));
      boxs.forEach(box => (box.asinStockList || []).forEach(asinStock => (outStockCount += asinStock.outStockCount)));
      return parseInt(outStockCount) || 0;
    },
    getOutStockSKUCount(row) {
      let noBoxAsinStockList = (row && row.noBoxAsinStockList) || [];
      let boxs = (row && row.boxs) || [];
      let skuSet = new Set([]);
      noBoxAsinStockList.forEach(item => item.sku && skuSet.add(item.sku));
      boxs.forEach(box => {
        (box.asinStockList || []).forEach(item => item.sku && skuSet.add(item.sku));
      });
      return skuSet.size;
    },
    beforeUpload() {
      this.uploadCount++;
    },
    clearUploadedFiles() {
      this.$refs.uploadFBAShipment && this.$refs.uploadFBAShipment.clearFiles();
      this.$refs.uploadAWDShipment && this.$refs.uploadAWDShipment.clearFiles();
    },
    finishUpload() {
      if (this.uploadCount != 0) return;
      this.getData();
      if (this.importErrorMessage) {
        const message = this.importErrorMessage;
        this.importErrorMessage = "";
        this.$message({
          type: "error",
          message: message,
        });
        this.clearUploadedFiles();
        return;
      }
      this.$confirm("导入完成", "提示", {
        confirmButtonText: "确定",
        type: "info",
      })
        .then(() => {
          this.clearUploadedFiles();
        })
        .catch(() => {
          this.clearUploadedFiles();
        });
    },
    onUploadSuccess(response) {
      if (response && response.code != null && response.code !== 0) {
        this.importErrorMessage = response.message || "导入失败";
      }
      this.uploadCount--;
      this.finishUpload();
    },
    onUploadError() {
      this.importErrorMessage = this.importErrorMessage || "导入失败";
      this.uploadCount--;
      this.finishUpload();
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getData();
    },
  },
  computed: {
    exportTitles() {
      let fields = {
        店铺名称: "shopName",
        产品名称: "productName",
        出库数量: "outStockCount",
      };
      return fields;
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#OutStockMgmt.out-stock-mgmt-page {
  .filter-toolbar {
    margin-top: 4px;
    padding-top: 10px;
    border-top: 1px dashed #ebeef5;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .filter-input-wide {
    width: 140px !important;

    .el-input {
      width: 140px;
    }
  }

  .filter-actions .el-button {
    width: auto;
    min-width: auto;
    margin: 0;
  }

  .col-header-main {
    line-height: 16px;
    font-weight: 600;
  }

  .col-header-sub {
    line-height: 14px;
    font-size: 11px;
    color: #909399;
    font-weight: 400;
  }

  .el-table .cell {
    padding-left: 4px;
    padding-right: 4px;
    line-height: 16px;

    .row-item {
      min-height: 16px;
    }

    .row-sub {
      color: #909399;
      font-size: 11px;
    }

    .text-ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .form-line {
    .form-label {
      margin: 5px 10px 5px 0px;
      width: 120px;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 220px;
      margin: 5px 0px;
      vertical-align: middle;
    }
    .form-date {
      margin: 5px 0px;
    }
    .form-select {
      width: 220px;
      margin: 5px 0px;
      vertical-align: middle;
    }
    .form-group {
      width: 750px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
    }

    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type="number"] {
      -moz-appearance: textfield;
    }
    input[aria-hidden="true"] {
      display: none !important;
    }
  }

  .upload-demo {
    text-align: right;
  }
}
#subOutputRank-print {
  .el-table--mini .el-table__cell {
    border-color: gray;
  }

  .title-content {
    display: inline-block;
    font-size: 14px;
    margin-right: 20px;
    height: 35px;
    line-height: 35px;

    .title-label {
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>
